import React from 'react';
import { LocaleString } from '@nackle/intl-tools';
import { Button, Modal } from '@nackle/origami';

const ErrorDialog = ( props ) =>{
    const {
        open,
        onClose,
    } = props;
    return (
        <Modal
            getContainer=".game-container"
            open={ open }
            onCancel={ onClose }
            title="Error loading game"
            centered
            footer={ (
                <Button
                    id="instructions_dialog_close"
                    type="primary"
                    onClick={ onClose }
                >
                    <LocaleString code="game.loader.INSTRUCTIONS.MODAL.CLOSE.BUTTON" />
                </Button>
            ) }
        >
                An error occurred loading this game.
        </Modal>
    );
};

export default ErrorDialog;